import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  getTelegramBotConfigs,
  getTelegramContacts,
  resetUnreadCount,
} from '../../reducers/telegram/telegram-action';
import { setSelectedBotConfig, setSelectedContact } from '../../reducers/telegram/telegram-slice';
import TelegramBotSelector from './components/TelegramBotSelector';
import TelegramContactCard from './components/TelegramContactCard';
import Chats from './Chats';
import Search from './search';

const Sidebar = () => {
  const dispatch = useDispatch();

  const { botConfigs, contacts, selectedBotConfigId, selectedContact, loading, page, limit } =
    useSelector((state) => state.telegram);

  // Load bot configs once
  useEffect(() => {
    dispatch(getTelegramBotConfigs({ page: 0, limit: 10 }));
  }, [dispatch]);

  useEffect(() => {
    if (!selectedBotConfigId && botConfigs.length > 0) {
      dispatch(setSelectedBotConfig(botConfigs[0].id));
    }
  }, [botConfigs, selectedBotConfigId, dispatch]);

  // Load contacts when bot changes
  useEffect(() => {
    if (selectedBotConfigId) {
      dispatch(
        getTelegramContacts({
          botConfigId: selectedBotConfigId,
          page: 0,
          limit,
        }),
      );
    }
  }, [dispatch, selectedBotConfigId, limit]);

  const refreshContacts = () => {
    dispatch(
      getTelegramContacts({
        botConfigId: selectedBotConfigId,
        page: 0,
        limit,
      }),
    );
  };

  return (
    <div className="__sidebar flex flex-column">
      {/* Bot Selector */}

      <div className="p-3 border-bottom-1 surface-border">
        <TelegramBotSelector
          botConfigs={botConfigs}
          selectedBotConfigId={selectedBotConfigId}
          onChange={(id) => dispatch(setSelectedBotConfig(id))}
        />
      </div>

      <Search />
      {/* Contacts List */}
      <Chats />
    </div>
  );
};

export default Sidebar;
